import { IvSegmentType, IvTrackType } from '../enums'

export const typeMap = {
  [IvSegmentType.Video]: IvTrackType.Video,
  [IvSegmentType.Audio]: IvTrackType.Audio,
  [IvSegmentType.Text]: IvTrackType.Text,
  [IvSegmentType.Image]: IvTrackType.Image,
  [IvSegmentType.Hand]: IvTrackType.Hand,
  [IvSegmentType.Freeze]: IvTrackType.Iv,
  [IvSegmentType.Loop]: IvTrackType.Iv,
  [IvSegmentType.Hold]: IvTrackType.Iv,
} as const
